module.exports = __webpack_public_path__ + "static/media/omega_deville.ecb4838c.jpg";